import { DOCUMENT } from '@angular/common';
import { computed, Directive, effect, inject, OnDestroy } from '@angular/core';
import { FEATURE_FLAGS } from '../../constants/feature-flags.constants';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';

@Directive({
  selector: '[libSystemDefaultColor]',
  host: {
    '[class.theme-system-default]': 'enabled()',
  },
})
export class SystemDefaultColorDirective implements OnDestroy {
  private readonly featureFlags = inject(FeatureFlagsService);
  private readonly document = inject(DOCUMENT);

  readonly enabled = computed(() =>
    this.featureFlags.getFeatureFlagValue(
      FEATURE_FLAGS.SYSTEM.system_default_color
    )
  );

  constructor() {
    effect(() => {
      this.document.documentElement.classList.toggle(
        'theme-system-default',
        this.enabled()
      );
    });
  }

  ngOnDestroy(): void {
    this.document.documentElement.classList.remove('theme-system-default');
  }
}
